export function isInEnum<T>(theEnum: Record<string, unknown>, theKey: any): theKey is T {
  const values = Object.values(theEnum);
  return values.includes(theKey);
}

export function areInEnum<T>(theEnum: Record<string, unknown>, theKeys: Array<any>): theKeys is Array<T> {
  const values = Object.values(theEnum);
  return !theKeys.find((k) => !values.includes(k));
}

export function getEnumValue<T>(theEnum: Record<string, unknown>, theKey: any): T | undefined {
  return isInEnum<T>(theEnum, theKey) ? theKey : undefined;
}
